export default "__VITE_ASSET__ReT7SX41__"